import { render, staticRenderFns } from "./OfferView.vue?vue&type=template&id=70c9c840&scoped=true"
import script from "./OfferView.vue?vue&type=script&lang=js"
export * from "./OfferView.vue?vue&type=script&lang=js"
import style0 from "./OfferView.vue?vue&type=style&index=0&id=70c9c840&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70c9c840",
  null
  
)

export default component.exports